import styled from "styled-components";

export default styled.div`

.plans{
  margin-left: 20px;
}
.imagePreview{
  width: 100%;
  max-width: 150px;
  min-width: 75px;  
}



`